import React, { useContext } from 'react'
import { Link, navigate } from 'gatsby'
import GitHubLogin from '../components/GitHubLogin'
// import { FirebaseContext } from '../components/Firebase'
import styled from 'styled-components'

const Links = ({ styleClass, children, toggle }) => {
  // const { firebase, user } = useContext(FirebaseContext)
  // function handleLogoutClick() {
  //   firebase.logout().then(() => navigate('/login'))
  // }
  return (
    <ul className={styleClass}>
      <li>
        <Link to="/" className="page-link" onClick={toggle}>
          Home
        </Link>
      </li>
      <li>
        <Link to="/projects" className="page-link" onClick={toggle}>
          Projects
        </Link>
        {children}
      </li>
      <li>
        <Link to="/submission" className="page-link" onClick={toggle}>
          Submission
        </Link>
      </li>
      <li>
        <Link to="/solutions" className="page-link" onClick={toggle}>
          Solutions
        </Link>
      </li>
      <li>
        <GitHubLogin />
      </li>
      {/* <li>
        <Link to="/project" className="page-link">
          Project
        </Link>
      </li> */}
      {/* <li>
        <Link to="/account" className="page-link">
          Account
        </Link>
      </li> */}
      {/* <li>
        {(!user || !user.email) && (
          <div>
            <Link to="/login" className="page-link" onClick={toggle}>
              Login
            </Link>
            <Link to="/register" className="page-link" onClick={toggle}>
              Register
            </Link>
          </div>
        )}
        {!!user && !!user.email && (
          <Link onClick={handleLogoutClick} className="page-link">
            Logout
          </Link>
        )}
      </li> */}
    </ul>
  )
}

export default Links
